export const LICENSE_IMPORT = "LICENSE_IMPORT";
export const LICENSE_ERROR = "LICENSE_ERROR";
export const LICENSE_CLEAR_ERROR = "LICENSE_CLEAR_ERROR";
export const LICENSE_CLEAR_DATA = "LICENSE_CLEAR_DATA";
export const LICENSE_EXISTS = "LICENSE_EXISTS";



// WEBPACK FOOTER //
// ./src/pages/license/state/types.js